import AbstractHandler from "./abstract-handler";
import request from '../../common/request';
import Const from '../../common/const';

class Handler extends AbstractHandler {
    constructor() {
        super();    
    }

    doSearchEvents = (path: string, param: any) => {
        return request.getData(path).then((res: any) => {
            return new Promise((resolv, reject) => {
                if (res.status !== 200) {
                    reject(new Error(`処理NG(${path}, ${res.data.detail})`));
                } else if (!res.data) {
                    reject(new Error(`NODATA${path}, ${JSON.stringify(param)}`));
                } else {
                    resolv(res.data);
                }
            })
        });
    }

    getReverseGeocoder = (path: string, latLng: any) => {
        return this.getRequest(path, latLng).then((res: any) => {
            if (res.result !== Const.API_RESULT.OK) {
                throw new Error(JSON.stringify({ msg: `処理NG`, error: res.err }));
            } else {
                return res.response;
            }
        });
    }
}

export default Handler;